<template>
  <v-container fluid>
    <PageTitle icon="fas fa-fw fa-paper-plane">
      Subscribers
    </PageTitle>
    <v-row>
      <v-col cols="12"
             md="3">
        <v-form @submit.prevent="search(true)"
                :disabled="form.busy">
          <v-card class="mb-4">
            <v-card-title class="font-weight-bold">
              <v-icon left>
                fal fa-fw fa-filter
              </v-icon>
              Filter
            </v-card-title>
            <v-card-text>
              <v-text-field v-model="form.email"
                            label="Email contains"
                            placeholder="Email contains"
                            autocomplete="new-email"
                            outlined
                            dense
                            hide-details>
              </v-text-field>
              <v-radio-group v-model="form.type"
                             label="Status"
                             hide-details>
                <v-radio label="Any"
                         :value="''">
                </v-radio>
                <v-radio v-for="type in types"
                         :key="type.id"
                         :label="type.name"
                         :value="type.name">
                </v-radio>
              </v-radio-group>
            </v-card-text>
            <v-card-actions class="px-4">
              <v-btn type="submit"
                     color="primary"
                     :disabled="form.busy">
                Search
              </v-btn>
              <v-btn @click="exportSubscribers"
                     :disabled="form.busy">
                Export
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>

      <v-col cols="12"
             md="9">
        <v-card>
          <v-data-table id="data-table"
                        :loading="form.busy"
                        :headers="headers"
                        :items="subscribers"
                        :items-per-page="form.per_page"
                        :footer-props="{'items-per-page-options': [50, 100, 500, 1000]}"
                        v-resize="adjustTableHeight"
                        dense
                        fixed-header
                        :height="tableHeight"
                        @options.sync="options"
                        :server-items-length="pagination.total"
                        @update:options="updateOptions">
            <template v-slot:item.type="{item: subscriber}">
              <a v-if="subscriber.is_active"
                 href="#"
                 @click.prevent="unsubscribe(subscriber)">
                {{ subscriber.type }}
              </a>
              <a v-else
                 href="#"
                 @click.prevent="resubscribe(subscriber)">
                {{ subscriber.type }}
              </a>
            </template>
            <template v-slot:item.created_at="{item: subscriber}">
              {{ subscriber.created_at | datetime('YYYY-MM-DD h:mm a') }}
            </template>
            <template v-slot:item.unsubscribed_at="{item: subscriber}">
              <template v-if="subscriber.is_unsubscribed">
                {{ subscriber.unsubscribed_at | datetime('YYYY-MM-DD h:mm a') }}
              </template>
            </template>
          </v-data-table>

        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import PageTitle from '../../components/PageTitle.vue';
import subscriberService from '../../../../ml/services/subscriberService';

export default {
  components: {
    PageTitle,
  },
  data() {
    return {
      form: new Form({
        email: '',
        order_by: 'email',
        order_dir: 'asc',
        page: 1,
        per_page: 100,
        type: '',
      }),
      options: {
        page: 1,
        itemsPerPage: 100,
        sortBy: ['email'],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
      },
      subscribers: [],
      tableHeight: '600px',
      types: subscriberService.getTypes(),
      pagination: {
        total: 0,
        count: 0,
        per_page: 100,
        total_pages: 1,
        links: {
          next: null,
        }
      },
    };
  },
  computed: {
    headers() {
      return [
        {
          text: 'Status',
          value: 'type',
          width: '110px',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: 'Subscribed',
          value: 'created_at',
          align: 'end',
          width: '180px',
        },
        {
          text: 'Unsubscribed',
          value: 'unsubscribed_at',
          align: 'end',
          width: '180px',
        },
      ];
    },
  },
  created() {
    this.search();
  },
  methods: {
    adjustTableHeight() {
      const scrollbarHeight = 22;
      const header = document.querySelector('#data-table .v-data-table-header');
      const footer = document.querySelector('#data-table .v-data-footer');
      if (header && footer) {
        const windowHeight = window.innerHeight;
        const headerTop = header.getBoundingClientRect().top;
        const footerHeight = footer.getBoundingClientRect().height + 12;
        const lastRowBottom = document.querySelector('#data-table tbody > tr:last-child')?.getBoundingClientRect().bottom;
        if (lastRowBottom) {
          if (lastRowBottom > windowHeight) {
            let height = windowHeight - headerTop - footerHeight;
            this.tableHeight = `${height}px`;
            //console.log(`set tableHeight = LAST ROW = ${this.tableHeight}`)
            return;
          }
        }
        // let maxHeight = windowHeight - headerTop - footerHeight;
        // this.tableHeight =`${maxHeight}px`;
        this.tableHeight = null;
        //console.log(`set tableHeight = maxHeight = ${this.tableHeight}`)
      } else {
        this.tableHeight = `600px`;
      }
    },
    updateOptions(options) {
      this.options = options;
      this.form.page = options.page;
      this.form.per_page = options.itemsPerPage;
      this.form.order_by = options.sortBy[0];
      this.form.order_dir = options.sortDesc[0] ? 'desc' : 'asc';
      this.search();
    },
    search(reset = false) {
      if (this.form.busy) {
        return;
      }
      if (reset) {
        this.form.page = 1;
      }
      this.form.startProcessing();
      return subscriberService.getSubscribers(this.form.data())
        .then(data => {
          this.subscribers = data.data;
          this.pagination = data.meta.pagination;
          this.form.finishProcessing();
          this.$nextTick(() => {
            this.adjustTableHeight();
          });
        })
        .catch(err => {
          this.$toast.error('There was a problem');
        })
        .finally(() => {
          this.form.busy = false;
        })
    },
    exportSubscribers() {
      if (this.form.busy) {
        return;
      }
      this.form.startProcessing();
      const form = {
        email: this.form.email,
        type: this.form.type,
      }
      return subscriberService.exportSubscribers(form)
        .then(data => {
          this.form.finishProcessing();
        })
        .catch((err) => {
          this.$toast.error('There was a problem');
        })
        .finally(() => {
          this.form.busy = false;
        });
    },
    resubscribe(subscriber) {
      if (this.form.busy) {
        return;
      }
      this.form.startProcessing();
      const form = {
        subscriber_id: [subscriber.id],
      }
      return subscriberService.resubscribe(form)
        .then(() => {
          this.form.finishProcessing();
          this.search();
        })
        .catch((err) => {
          this.$toast.error('There was a problem');
        })
        .finally(() => {
          this.form.busy = false;
        });
    },
    unsubscribe(subscriber) {
      if (this.form.busy) {
        return;
      }
      this.form.busy = true;
      const form = {
        subscriber_id: [subscriber.id],
      }
      return subscriberService.unsubscribe(form)
        .then(() => {
          this.form.finishProcessing();
          this.search();
        })
        .catch((err) => {
          this.$toast.error('There was a problem');
        })
        .finally(() => {
          this.form.busy = false;
        });
    },
  },
}
</script>
